import { Component } from '@angular/core';

@Component({
    selector: 'app-routes-aux',
    template: 'Component Aux',
    standalone: false
})
export default class RoutesAuxComponent {}
